import { render, staticRenderFns } from "./SectionSeparator.vue?vue&type=template&id=449ef22e&lang=html&"
import script from "./SectionSeparator.vue?vue&type=script&lang=js&"
export * from "./SectionSeparator.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SectionSeparator.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "72830792"
  
)

export default component.exports